import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import DebounceInput from "react-debounce-input"
import { FormattedMessage, FormattedNumber, defineMessages, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import LabelHelper from "../../common/LabelHelper.jsx"
import Integrations from "../../integration/Integrations.jsx"
import BillingMethodLabel from "../../product/billing-method/label.component.jsx"
import PriceLevelSelect from '../../product/price-level/PriceLevelSelect'
import { Guard, Permissions } from "../../role/Guard.jsx"
import { Settings, SupportedSettings } from "../../settings/account/Settings.jsx"
import { isError } from '../../state/helpers/Error'
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { InventoryLocationSelector } from '../../state/inventory/location/selectors'
import { INVOICES } from '../../state/invoice/Constants.ts'
import { getPricingTableGroups, getPricingTableItem, getPricingTableItemTax, getPricingTableTotals } from '../../state/pricing/selectors'
import Product from '../../state/product/Product'
import { PRODUCT_TYPE } from "../../state/product/Types"
import SearchService from "../../state/search/SearchService.ts"
import { getCustomAttributes, matchCustomDefnToValue } from "../../utils"
import { INVENTORY_STOCK_DIRECTION } from '../../utils/inventory'
import { getInventoryLocationFromLocation, getQuantityAvailableByInventoryLocationId } from '../../utils/inventory/utils'
import { PRICING_TABLES } from "../../utils/pricing/constants"
import { hasHistoryWithRowID } from '../../utils/serial-numbers/'
import EventBus from "../EventBus.js"
import GlobalHelper from '../GlobalHelper.jsx'
import ActionButton from "../button/actionbutton.component.jsx"
import CustomAttributeWrapper from '../form/CustomAttributeWrapper'
import MoneyInputForm from "../form/moneyinput.component.jsx"
import Icon from "../icon/icon.component.jsx"
import ImageUploaderDropZone from "../image-uploader/dropzone.component.jsx"
import Image from '../image/image.component.jsx'
import LabelSelect from '../label/selection.component.jsx'
import NoResult from "../listing/noresult.component.jsx"
import Pagination from "../listing/pagination.component.jsx"
import LoadingSpinner from "../spinner/loading.component.jsx"
import InputUnitOfMeasure from '../unit-of-measure/input.component.jsx'
import SelectUnitOfMeasure from '../unit-of-measure/select.component.jsx'
import ModalSearchAssemblyParts from "./add-item-modal/assemblyparts.component.jsx"
import ModalSearchCalculatorInput from './add-item-modal/calculator.component.jsx'
import BundleOptionsDisplay from "./add-item-modal/components/BundleOptionsDisplay"
import MatrixSelection from "./add-item-modal/components/MatrixSelection"
import UnitPriceInput from "./add-item-modal/components/UnitPriceInput"
import ModalSearchProductList from "./add-item-modal/productList.component.jsx"
import "./add-item-modal/styles/AddItemStyles.scss"
import CommitmentDurationInput from "./commitmentdurationinput.component.jsx"
import SerialNumberSelect from "./components/SerialNumberSelect"
import GroupSelect from "./groupselection.component.jsx"

const messages = defineMessages({
    "product_name_placeholder": {
        id: 'quote.quick_create_modal.product_name_placeholder',
        defaultMessage: 'Name of the product',
    },
    "product_short_description_placeholder": {
        id: 'quote.quick_create_modal.short_description_placeholder',
        defaultMessage: 'A few words to describe the product',
    },
    "search_product_placeholder": {
        id: 'quote.add_item_modal.placeholder.search_product',
        defaultMessage: 'Search for a product...',
    },
    "label_filter_placeholder": {
        id: 'quote.add_item_modal.placeholder.label_filter',
        defaultMessage: 'Label filters',
    },
    "quote.add_item_modal.configure.no_group_label": {
        id: 'quote.add_item_modal.configure.no_group_label',
        defaultMessage: 'No group',
    },
})

class AddPricingRow extends Component {

    constructor(props, context) {
        super(props, context);


        const priceRuleIsEnabled = AppContext.hasFeatureIntegration(Features.ExternalPricingCalculation)
        const inventoryEnabled = GlobalHelper.isQBOInventorySyncVisible(AppContext.hasFeatureIntegration(Features.InventorySync))
        const inventoryLevelEnabled = AppContext.hasFeatureIntegration(Features.InventoryLevel)

        this.state = {
            selectedProductId: '',
            unitOfMeasure: 'piece',
            additionalUnitOfMeasure: '',
            title: '',
            shortDescription: '',
            images: [],
            measure: '1',
            additionalMeasure: '0',
            taxable: null,
            feeApplicable: null,
            longDescription: '',
            unitPrice: '',
            unitCost: '',
            billingMethods: [],
            billingMethod: '',
            defaultUnitPrice: '',
            monthlyUnitPrice: '',
            yearlyUnitPrice: '',
            defaultUnitCost: '',
            monthlyUnitCost: '',
            yearlyUnitCost: '',
            groupId: '',
            newGroupName: '',
            commitmentDuration: 0,
            searchKeywords: '',
            searchLabelIds: [],
            activePage: 1,
            pageSize: 5,
            totalItemsCount: 0,
            products: [],
            assemblyPart: '',
            matrixSelection: '',
            matrixSelectedIds: [],
            calculatorResults: [],
            calculatorValues: {},
            displayPriceCalculation: '',
            pricingStrategy: '',
            notification: '',
            isAssembly: false,
            isLoading: true,
            saveItemLoading: false,
            saveAndContinueItemLoading: false,
            enterKeyPressed: false,
            assemblyConfiguration: [],
            initialAssemblyConfiguration: [],
            groups: this.props.groups || [],
            itemStatus: this.props.itemStatus || 'active',
            currency: this.props.currency,
            exchangeRate: this.props.exchangeRate || '1',
            forceBillingMethod: this.props.forceBillingMethod || '',
            hideStatusModification: this.props.hideStatusModification || false,
            hideQuickProduct: this.props.hideQuickProduct || false,
            allowedProductTypes: this.props.allowedProductTypes || ["matrix-parent", "single", "assembly", "bundle"],
            product: null,
            itemId: '',
            matrixItem: null,
            quoteItem: null,
            quickProductTitle: '',
            quickProductShortDescription: '',
            quickProductLongDescription: '',
            quickProductUnitOfMeasure: 'piece',
            quickProductUnitPrice: '',
            quickProductUnitCost: '0',
            quickProductMeasure: '1',
            quickProductBillingMethod: 'one-time',
            quickProductImages: [],
            quickProductImageIds: [],
            quickAddToCatalog: true,
            priceRuleIsEnabled,
            inventoryEnabled,
            inventoryLevelEnabled,
            isReturn: this.props.isReturn || false,
            inventoryCollapseExpanded: this.props.inventoryCollapseExpanded || false,
            location: this.props.location || null,
            currentProductIds: [],
            currentProductIdsIndex: 0,
            itemCustomAttributes: [],
            isItemCustomAttributesUpdated: false,
            isSaveButtonDisabled: false,
            matrixActiveItems: [],
            selectedPriceLevelId: '',
            editItemSelectedPriceLevelId: '',
            priceLevels: null,
            serialNumbersUpdated: false,
            serialNumbers: [],
            serialNumbersWithHistory: null,
            stockDocument: this.props.stockDocument || null,
            referenceRowId: ''
        }
        this.onItemAdd = this.props.onItemAdd
        this.objectId = this.props.objectId
        this.objectIdentifier = this.props.objectIdentifier
        this.sectionId = this.props.sectionId
        this.mainObject = this.props.mainObject
        this.mainObjectItem = this.props.mainObjectItem

        this.addProduct = this.addProduct.bind(this)
        this.getPrice = this.getPrice.bind(this)
        this.productSelect = this.productSelect.bind(this)
        this.handleMeasureChange = this.handleMeasureChange.bind(this)
        this.chooseProductLineButton = this.chooseProductLineButton.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.closeConfigurationModal = this.closeConfigurationModal.bind(this)
        this.addBundleProduct = this.addBundleProduct.bind(this)
        this.chooseProductMainButton = this.chooseProductMainButton.bind(this)
        this.assemblySelectionChange = this.assemblySelectionChange.bind(this)
        this.matrixItemSelect = this.matrixItemSelect.bind(this)
        this.onLabelSelectChange = this.onLabelSelectChange.bind(this)
        this.handleUnitOfMeasureChange = this.handleUnitOfMeasureChange.bind(this)
        this.handleQuickCreateFormChange = this.handleQuickCreateFormChange.bind(this)
        this.handleQuickProductMeasureChange = this.handleQuickProductMeasureChange.bind(this)
        this.addQuickProduct = this.addQuickProduct.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleCalculatorChange = this.handleCalculatorChange.bind(this)
        this.deleteItem = this.deleteItem.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.quickCreateProduct = this.quickCreateProduct.bind(this)
        this.validateQuickCreateForm = this.validateQuickCreateForm.bind(this)
        this.backToChooseProduct = this.backToChooseProduct.bind(this)
        this.handleAdditionalMeasureChange = this.handleAdditionalMeasureChange.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.handleClearFilters = this.handleClearFilters.bind(this)
        this.addProductAndContinue = this.addProductAndContinue.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
        this.multiCreateProduct = this.multiCreateProduct.bind(this)
        this.searchProductIds = this.searchProductIds.bind(this)
        this.renderItemCustomAttributesFields = this.renderItemCustomAttributesFields.bind(this)
        this.onSerialNumberChange = this.onSerialNumberChange.bind(this)
        this.getSerialNumberPayload = this.getSerialNumberPayload.bind(this)
        this.validateSerialNumberHistory = this.validateSerialNumberHistory.bind(this)
        this.getTaxRate = this.getTaxRate.bind(this)
    }

    componentDidMount() {
        if (this.props.itemId) {
            this.loadQuoteItem(this.props.itemId)
        } else if (this.props.productId) {
            this.productSelect(this.props.productId)
            $('#configureQuoteItemModal').modal('show')
        } else {
            if (this.sectionId) {
                AppContext.getApiClient().get('/guided-selling-sections/' + this.sectionId).then(res => {
                    this.setState({
                        searchLabelIds: res.attributes.labelIds
                    }, () => {
                        this.refreshSearch()
                    })
                })
            } else {
                GlobalHelper.getListingPreferences(this.preferenceType(), false).then(pref => {
                    this.setState({
                        activePage: pref.page,
                        pageSize: pref.pageSize,
                        searchKeywords: pref.keywords || "",
                        searchLabelIds: pref.filters && pref.filters.searchLabelIds ? pref.filters.searchLabelIds : [],
                    }, () => {
                        this.refreshSearch()
                        this.focusAndSelect()
                    })
                })
            }
            $('#addPricingRowModal').modal('show')
            this.focusAndSelect()
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            location: nextProps.location,
            groups: nextProps.groups || [],
        })
    }

    addProductOnCreateQuoteItem(measure) {
        this.createQuoteItem(this.state.selectedProductId, measure, this.state.additionalMeasure)
            .then(res => {
                if (res.error) {
                    this.setState({
                        saveItemLoading: false,
                        saveAndContinueItemLoading: false,
                    })
                    return
                }

                if (this.state.currentProductIdsIndex + 1 < this.state.currentProductIds.length) {
                    this.setState({
                        currentProductIdsIndex: this.state.currentProductIdsIndex + 1,
                        saveItemLoading: false,
                        saveAndContinueItemLoading: false,
                        serialNumbers: [],
                    }, () => {
                        this.productSelect(this.state.currentProductIds[this.state.currentProductIdsIndex])
                        this.chooseProductLineButton(this.state.currentProductIds[this.state.currentProductIdsIndex])
                    })
                } else {
                    this.setState({
                        currentProductIds: [],
                        currentProductIdsIndex: 0,
                    })
                    this.quit()
                }
            })
    }

    addProduct(event) {
        event.preventDefault()
        if (!this.validateAllForms()) {
            return
        }

        /* if (!customAttributesAreValid(this.state.itemCustomAttributes, this.state.product?.attributes?.customAttributeDefinitions)) {
            return
        } */

        this.setState({
            saveItemLoading: true
        })
        const measure = this.state.isReturn ? '-' + this.state.measure : this.state.measure

        if (this.state.itemId) {
            this.updateQuoteItem()
                .then(res => {
                    if (res.error) {
                        this.setState({
                            saveItemLoading: false,
                            saveAndContinueItemLoading: false,
                        })
                        return
                    }
                    this.quit()
                }
                )
        } else if (this.state.isAssembly) {
            this.createConfigurableQuoteItem(this.state.selectedProductId, measure, this.state.additionalMeasure)
                .then(_ => this.quit())
        } else {
            if (this.state.inventoryLevelEnabled && this.mainObject == 'orders' && this.state.location) {
                AppContext.getApiClient().post(`/locations/${this.state.location.id}/products/${this.state.selectedProductId}/verify-inventory-level`, {}).then(res => {
                    if (!res.error) {
                        this.addProductOnCreateQuoteItem(measure)
                    } else {
                        this.setState({
                            saveItemLoading: false,
                        })
                    }
                })
            } else {
                this.addProductOnCreateQuoteItem(measure)
            }
        }

    }

    getSerialNumberPayload() {
        return this.state.serialNumbers.map(s => {
            return {
                serial: s,
                productId: this.state.selectedProductId,
                saleId: this.state.stockDocument?.id || this.objectId,
                saleType: this.mainObject,
                identifier: this.objectIdentifier,
                saleStatus: this.props.object?.attributes.status || this.state.stockDocument?.status.attributes.state,
                transactionDate: this.props.object?.attributes.createdAt || this.state.stockDocument?.createdAt,
                contactId: this.props.object?.attributes.contactId || this.state.stockDocument?.project.attributes.contactId,
            }
        })
    }

    addProductAndContinue(event) {
        event.preventDefault()
        if (!this.validateAllForms()) {
            return
        }

        /* if (!customAttributesAreValid(this.state.itemCustomAttributes, this.state.product?.attributes?.customAttributeDefinitions)) {
            return
        } */

        this.setState({
            saveAndContinueItemLoading: true,
        })

        const measure = this.state.isReturn ? '-' + this.state.measure : this.state.measure
        this.createQuoteItem(this.state.selectedProductId, measure, this.state.additionalMeasure)
            .then(_ => this.quit(true))
    }

    addQuickProduct(event) {
        if (!this.validateQuickCreateForm()) {
            return
        }
        if (this.state.itemId) {
            this.updateQuoteItem().then(_ =>
                this.quit()
            )
        } else {
            const measure = this.state.isReturn ? '-' + this.state.quickProductMeasure : this.state.quickProductMeasure
            AppContext.getApiClient().post('/' + this.mainObject + '/' + this.objectId + '/quick-products', {
                measure: measure || '0',
                sectionId: this.sectionId,
                status: this.state.itemStatus,
                taxable: true,
                feeApplicable: true,
                billingMethod: this.state.billingMethod || 'one-time',
                commitmentDuration: parseInt(this.state.commitmentDuration),
                groupId: this.state.groupId,
                quickProduct: {
                    title: this.state.quickProductTitle,
                    addToCatalog: this.state.quickAddToCatalog,
                    shortDescription: this.state.quickProductShortDescription,
                    billingMethod: this.state.forceBillingMethod || this.state.billingMethod || 'one-time',
                    longDescription: this.state.quickProductLongDescription,
                    unitOfMeasure: this.state.quickProductUnitOfMeasure,
                    defaultUnitCost: this.state.quickProductUnitCost || '0',
                    defaultUnitPrice: this.state.quickProductUnitPrice || '0',
                    imageIds: this.state.quickProductImageIds,
                },
                isReturn: this.state.isReturn,
            }).then(_ => this.quit())
        }
        event.preventDefault()
    }

    handleFocus(event) {
        event.target.select()
    }

    quit(leaveOpen, showProductAddedNotificationEnabled = true) {
        $('#configureQuoteItemModal').modal('hide')
        $('#quickCreateProductModal').modal('hide')
        if (leaveOpen && showProductAddedNotificationEnabled) {
            $('#addPricingRowModal').modal('show')
            this.focusAndSelect()
            this.showNotification(<FormattedMessage
                id="quote.add_item_modal.notification.product_added"
                defaultMessage="{title} was just added!"
                values={{
                    title: <strong>{this.state.title}</strong>
                }}
            />)
        }
        this.setState({
            measure: "1",
            serialNumbers: [],
            serialNumbersUpdated: false,
            saveItemLoading: false,
            saveAndContinueItemLoading: false,
        })
        this.onItemAdd(leaveOpen)
    }

    chooseProductMainButton(event) {
        event.preventDefault()
        this.chooseProduct(this.state.selectedProductId)
    }

    chooseProduct(productId) {
        $('#addPricingRowModal').modal('hide')
        $('#configureQuoteItemModal').modal('show')
        this.setState({
            measure: this.state.measure,
            selectedProductId: productId,
        })
    }

    chooseProductLineButton(productId) {
        this.chooseProduct(productId)
    }

    createConfigurableQuoteItem(productId, measure, additionalMeasure) {
        const groups = this.state.groups.filter(g => [this.state.billingMethod, ""].includes(g.attributes.billingMethod))
        if (groups.length === 0 && this.state.newGroupName === '') {
            this.state.groupId = ""
        }
        return AppContext.getApiClient().post('/' + this.mainObject + '/' + this.objectId + '/assemblies', {
            measure: measure || '0',
            additionalMeasure: additionalMeasure || '0',
            productId: productId,
            sectionId: this.sectionId,
            commitmentDuration: parseInt(this.state.commitmentDuration),
            billingMethod: this.state.billingMethod || 'one-time',
            configurations: this.state.assemblyConfiguration,
            status: this.state.itemStatus,
            groupId: this.state.groupId,
            taxable: this.state.taxable,
            feeApplicable: this.state.feeApplicable,
        })
    }

    getCalculatorValues() {
        const values = []
        for (let varName in this.state.calculatorValues) {
            values.push({
                variableName: varName,
                value: this.state.calculatorValues[varName] || '0',
                calculatorId: this.state.product.attributes.calculator.id,
            })
        }
        return values
    }

    isUnitPriceEditable() {
        return ((['multiplier', 'custom-formula'].includes(this.state.pricingStrategy)
            && !this.isMatrix() && !this.state.isAssembly) && !this.state.priceRuleIsEnabled) || this.state.selectedPriceLevelId
    }

    createQuoteItem(productId, measure, additionalMeasure) {
        const groups = this.state.groups.filter(g => [this.state.billingMethod, ""].includes(g.attributes.billingMethod))
        if (groups.length === 0 && this.state.newGroupName === '') {
            this.state.groupId = ""
        }

        let data = {
            measure: measure || '0',
            additionalMeasure: additionalMeasure || '0',
            productId: productId,
            productType: this.state.product?.attributes.type,
            bundleItemDtos: this.state.product?.attributes.bundle?.attributes.bundleProducts || [],
            sectionId: this.sectionId,
            priceLevelId: this.state.selectedPriceLevelId !== this.state.editItemSelectedPriceLevelId
                && this.state.editItemSelectedPriceLevelId ?
                this.state.editItemSelectedPriceLevelId : this.state.selectedPriceLevelId,
            groupId: this.state.groupId,
            newGroupName: this.state.newGroupName,
            status: this.state.itemStatus,
            commitmentDuration: parseInt(this.state.commitmentDuration),
            billingMethod: this.state.forceBillingMethod || this.state.billingMethod,
            taxable: this.state.taxable,
            feeApplicable: this.state.feeApplicable,
            calculatorValues: this.getCalculatorValues(),
            isReturn: this.state.isReturn,
            itemCustomAttributeValues: this.state.itemCustomAttributes,
            serialNumbers: this.getSerialNumberPayload(),
        }


        if (this.state.product && !this.state.product.attributes.productPrices &&
            this.state.selectedPriceLevelId || !this.state.editItemSelectedPriceLevelId) {
            data.priceLevelId = ""
        }

        if (this.state.stockDocument && this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN) {
            data.updateInventoryRequested = true
        }
        if (this.isUnitPriceEditable()) {
            const selectedPriceLevel = this.state.product?.attributes?.productPrices?.find(p => p.attributes.priceLevelId == data.priceLevelId)
            data.unitPrice = selectedPriceLevel?.attributes.price || this.state.unitPrice
            data.unitCost = this.state.unitCost
        }
        if (this.state.stockDocument && this.isMatrix()) {
            data.unitCost = String(this.getSelectedMatrixVariantCost())
        }
        return AppContext.getApiClient().post('/' + this.mainObject + '/' + this.objectId + '/products', data)
    }

    updateQuoteItem() {
        const groups = this.state.groups.filter(g => [this.state.billingMethod, ""].includes(g.attributes.billingMethod))
        if (groups.length === 0 && this.state.newGroupName === '') {
            this.state.groupId = ""
        }
        let updates = {}

        if (this.state.stockDocument && this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN) {
            updates.updateInventoryRequested = true
        }
        if (this.state.quoteItem.attributes.measure !== this.state.measure) {
            updates.measure = this.state.measure || '0'
        }
        if (this.state.quoteItem.attributes.selectedPriceLevelId !== this.state.selectedPriceLevelId) {
            updates.priceLevelId = this.state.selectedPriceLevelId
        }
        if (this.state.quoteItem.attributes.additionalMeasure !== this.state.additionalMeasure) {
            updates.additionalMeasure = this.state.additionalMeasure || '0'
        }
        if (this.state.quoteItem.attributes.itemObject.id !== this.state.selectedProductId) {
            updates.productId = this.state.selectedProductId
        }
        if (this.state.quoteItem.attributes.status !== this.state.itemStatus) {
            updates.status = this.state.itemStatus
        }
        if (this.state.quoteItem.attributes.commitmentDuration !== this.state.commitmentDuration) {
            updates.commitmentDuration = parseInt(this.state.commitmentDuration)
        }
        if (this.state.quoteItem.attributes.billingMethod !== this.state.billingMethod) {
            updates.billingMethod = this.state.billingMethod
        }
        if (this.state.quoteItem.attributes.groupId !== this.state.groupId) {
            updates.groupId = this.state.groupId
            updates.newGroupName = this.state.newGroupName
        }
        if (this.state.matrixSelection === '' && !this.state.isAssembly) {
            updates.unitPrice = this.state.unitPrice
        }
        if (this.state.quoteItem.attributes.unitCost !== this.state.unitCost && this.state.matrixSelection === '' && !this.state.isAssembly) {
            updates.unitCost = this.state.unitCost
        }
        if (this.state.isAssembly) {
            updates.configurations = this.state.assemblyConfiguration
        }
        if (this.state.isItemCustomAttributesUpdated) {
            updates.customAttributeValues = this.state.itemCustomAttributes
        }
        if (this.state.serialNumbersUpdated) {
            updates.serialNumbers = this.getSerialNumberPayload()
        }
        updates.taxable = this.state.taxable

        if (this.state.quoteItem.attributes.itemObject.type === "quick-products") {
            updates.quickProduct = {
                title: this.state.quickProductTitle,
                shortDescription: this.state.quickProductShortDescription,
                longDescription: this.state.quickProductLongDescription,
                unitOfMeasure: this.state.quickProductUnitOfMeasure,
                billingMethod: this.state.billingMethod,
                defaultUnitCost: this.state.quickProductUnitCost || '0',
                defaultUnitPrice: this.state.quickProductUnitPrice || '0',
                imageIds: this.state.quickProductImageIds,
            }
            updates.measure = this.state.quickProductMeasure || '0'
            delete updates.productId
        }
        updates.mainObjectId = this.objectId
        updates.calculatorValues = this.getCalculatorValues()

        let endpoint = `/${this.mainObjectItem}/${this.state.itemId}`
        if (this.props.mainObject === PRICING_TABLES) {
            endpoint = `/pricing-tables/rows/${this.state.itemId}`
        }
        return AppContext.getApiClient().patch(endpoint, updates)
    }

    multiCreateProduct(productIds, groupId) {
        const groups = this.state.groups.filter(g => [this.state.billingMethod, ""].includes(g.attributes.billingMethod))
        if (groups.length === 0 && this.state.newGroupName === '') {
            this.state.groupId = ""
        }
        let data = {
            productIds: productIds,
            groupId: groupId,
            newGroupName: this.state.newGroupName,
            measure: this.state.measure,
            itemCustomAttributeValues: this.state.itemCustomAttributes,
        }

        if (this.state.stockDocument) {
            data.unitCost = this.state.unitCost
        }

        this.setState({
            currentProductIds: [],
            currentProductIdsIndex: 0,
            saveItemLoading: true,
            saveAndContinueItemLoading: true,
        })

        return AppContext.getApiClient().post('/' + this.mainObject + '/' + this.objectId + '/multi-products', data)
    }


    matrixItemSelect(matrixItem) {
        if (!matrixItem) {
            this.setState({
                isSaveButtonDisabled: true
            })
        } else {
            this.setState({
                isSaveButtonDisabled: false,
                selectedProductId: matrixItem.attributes.productId,
            })
        }
    }

    getPriceByCurrency(product) {
        const pricing = {
            oneTimePrice: '0',
            monthlyPrice: '0',
            yearlyPrice: '0',
        }
        if (this.state.currency === product.attributes.currency) {
            pricing.oneTimePrice = product.attributes.defaultUnitPrice
            pricing.monthlyPrice = product.attributes.monthlyUnitPrice
            pricing.yearlyPrice = product.attributes.yearlyUnitPrice

            pricing.oneTimeCost = product.attributes.defaultUnitCost
            pricing.monthlyCost = product.attributes.monthlyUnitCost
            pricing.yearlyCost = product.attributes.yearlyUnitCost

            return pricing
        }
        const currencyPricing = product.attributes.multiCurrencyPricing.filter(p => p.currency === this.state.currency)[0]
        if (currencyPricing) {
            return currencyPricing
        }
        pricing.oneTimePrice = (parseFloat(product.attributes.defaultUnitPrice) * parseFloat(this.state.exchangeRate)).toFixed(2)
        pricing.monthlyPrice = (parseFloat(product.attributes.monthlyUnitPrice) * parseFloat(this.state.exchangeRate)).toFixed(2)
        pricing.yearlyPrice = (parseFloat(product.attributes.yearlyUnitPrice) * parseFloat(this.state.exchangeRate)).toFixed(2)

        pricing.oneTimeCost = (parseFloat(product.attributes.defaultUnitCost) * parseFloat(this.state.exchangeRate)).toFixed(2)
        pricing.monthlyCost = (parseFloat(product.attributes.monthlyUnitCost) * parseFloat(this.state.exchangeRate)).toFixed(2)
        pricing.yearlyCost = (parseFloat(product.attributes.yearlyUnitCost) * parseFloat(this.state.exchangeRate)).toFixed(2)

        return pricing
    }

    displayEstimatedCost(product, unitCost) {
        if (["orders", INVOICES, "quotes", "price-lists"].includes(this.mainObject) && unitCost) {
            return unitCost
        }

        if (["orders", INVOICES, PRICING_TABLES].includes(this.mainObject)) {
            if (this.state.stockDocument && this.state.stockDocument.definition.attributes.direction !== INVENTORY_STOCK_DIRECTION.OUT) {
                const supplierId = this.state.stockDocument.project.attributes.contactId
                return this.getCostBySupplierId(product, supplierId)
            }

            let location = this.state.location
            if (location && this.props.documentInventoryLocations.length > 0) {
                const inventoryLocation = getInventoryLocationFromLocation(location.id, this.props.documentInventoryLocations)
                const inventoryLocationId = inventoryLocation?.id ?? ""
                return inventoryLocationId !== "" ? this.getCostOfProductByInventoryLocation(this.state.product, inventoryLocationId) : this.state.defaultUnitCost
            }
        }

        return product.attributes.defaultUnitCost
    }

    getCostOfProductByInventoryLocation(product, inventoryLocationId) {
        if (product.attributes.inventoryLocationEstimatedCosts?.length > 0) {
            const allEstimatedCosts = product.attributes.inventoryLocationEstimatedCosts
            const productCost = allEstimatedCosts.find((estimatedCost) => estimatedCost.attributes.inventoryLocationId === inventoryLocationId)
            if (productCost) {
                return productCost.attributes.estimatedCost
            }
        }
        return product.attributes.defaultUnitCost
    }

    getCostBySupplierId(prod, supplierId) {
        const defaultCost = prod.attributes.defaultUnitCost
        const supplierCosts = prod.attributes.supplierCosts
        const supplierCost = supplierCosts?.find(sc => sc.attributes.supplierId === supplierId)
        if (supplierCost) {
            return supplierCost.attributes.cost ?? defaultCost
        }
        return defaultCost
    }

    productSelect(productId, callback) {
        this.setState({
            isProductLoading: true,
            selectedProductId: productId,
            matrixSelection: ''
        }, () => {
            AppContext.getApiClient().get('/products/' + productId).then((response) => {
                let billingMethod = this.state.billingMethod
                if (!billingMethod) {
                    billingMethod = response.attributes.billingMethods.length > 0 ? response.attributes.billingMethods[0] : 'one-time'
                }

                let newItemCustomAttributes
                if (this.state.itemId === '' && response.attributes.customAttributeDefinitions) {
                    newItemCustomAttributes = getCustomAttributes(response.attributes)
                }

                let newState = {
                    isProductLoading: false,
                    title: response.attributes.title,
                    shortDescription: response.attributes.shortDescription,
                    longDescription: response.attributes.longDescription,
                    images: response.attributes.images,
                    unitOfMeasure: response.attributes.unitOfMeasure,
                    additionalUnitOfMeasure: response.attributes.additionalUnitOfMeasure,
                    isAssembly: response.attributes.type === "assembly",
                    assemblyPart: '',
                    billingMethods: response.attributes.billingMethods,
                    pricingStrategy: response.attributes.pricingStrategy,
                    billingMethod: billingMethod,
                    taxable: !response.attributes.taxExempt,
                    product: response,
                    itemCustomAttributes: newItemCustomAttributes ?? this.state.itemCustomAttributes,
                }

                if (!this.props.itemId) {
                    const pricing = this.getPriceByCurrency(response)
                    switch (billingMethod) {
                        case 'one-time':
                            newState.unitPrice = pricing.oneTimePrice
                            newState.unitCost = pricing.oneTimeCost
                            break
                        case 'monthly':
                            newState.unitPrice = pricing.monthlyPrice
                            newState.unitCost = pricing.monthlyCost
                            break
                        case 'yearly':
                            newState.unitPrice = pricing.yearlyPrice
                            newState.unitCost = pricing.yearlyCost
                            break

                    }

                    if (this.state.stockDocument) {
                        switch (this.state.stockDocument.definition.attributes.direction) {
                            case INVENTORY_STOCK_DIRECTION.OUT:
                                newState.unitCost = this.getCostOfProductByInventoryLocation(response, this.state.stockDocument.inventoryLocationId)
                                break
                            case INVENTORY_STOCK_DIRECTION.IN:
                                newState.unitCost = this.getCostBySupplierId(response, this.state.stockDocument.project.attributes.contactId)
                                break
                            default:
                                newState.unitCost = response.attributes.defaultUnitCost
                        }
                    }


                    newState.defaultUnitPrice = pricing.oneTimePrice
                    newState.monthlyUnitPrice = pricing.monthlyPrice
                    newState.yearlyUnitPrice = pricing.yearlyPrice

                    newState.defaultUnitCost = pricing.oneTimeCost
                    newState.monthlyUnitCost = pricing.monthlyCost
                    newState.yearlyUnitCost = pricing.yearlyCost
                }

                const productPrices = response?.attributes.productPrices || []
                const priceLevel = productPrices?.find(p => p.attributes.priceLevelId === this.state.selectedPriceLevelId && !p.attributes.isArchived)

                if (priceLevel) {
                    newState.unitPrice = priceLevel.attributes.price
                }

                if (this.state.taxable === null) {
                    newState.taxable = !response.attributes.taxExempt
                }
                if (this.state.feeApplicable === null) {
                    newState.feeApplicable = !response.attributes.feeExempt
                }
                const matrixActiveItems = response.attributes.matrix?.attributes.items.filter(i => !i.attributes.deleted) || []
                newState.matrixActiveItems = matrixActiveItems

                if (response.attributes.type === "matrix-parent" && matrixActiveItems.length === 1) {
                    newState.selectedProductId = matrixActiveItems[0].attributes?.productId
                    newState.isSaveButtonDisabled = false
                }

                if (response.attributes.type === "matrix-parent" && (matrixActiveItems.length === 0 || matrixActiveItems.length > 1)) {
                    newState.isSaveButtonDisabled = true
                }

                this.setState(newState, () => {
                    if (callback) {
                        callback(response)
                    }
                })
            })
        })
    }

    assemblySelectionChange(configurations) {
        this.setState({
            assemblyConfiguration: configurations.filter(c => c.partChoiceId !== '')
        })
    }

    handleCalculatorChange(calcResult) {
        const newState = {
            calculatorResults: calcResult.results,
            calculatorValues: calcResult.values,
        }
        if (this.state.product.attributes.type !== "assembly" &&
            calcResult.results.length > 0 &&
            calcResult.results[0].result !== '###'
        ) {
            newState.measure = calcResult.results[0].result
        }
        this.setState(newState)
    }


    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.refreshSearch()
        })
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size
        }, () => {
            this.refreshSearch()
        })
    }

    handleClearFilters() {
        this.setState({
            activePage: 1,
            searchLabelIds: [],
            searchKeywords: '',
        }, () => {
            this.refreshSearch()
        })
    }

    handleMeasureChange(measure) {
        this.setState({
            measure: measure
        })
    }

    handleAdditionalMeasureChange(measure) {
        this.setState({
            additionalMeasure: measure
        })
    }

    onLabelSelectChange(labelIds) {
        this.setState({
            searchLabelIds: labelIds,
            activePage: 1,
        }, () => {
            this.refreshSearch()
            if (!this.selectableModalSearchProductList()) {
                this.setState({
                    currentProductIds: [],
                    currentProductIdsIndex: 0,
                })
            }
        })
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value.replace(/\r?\n|\r/g, ''),
            activePage: 1,
        }, () => {
            this.refreshSearch()
            if (!this.selectableModalSearchProductList()) {
                this.setState({
                    currentProductIds: [],
                    currentProductIdsIndex: 0,
                })
            }
        })
    }

    handleUnitOfMeasureChange(unit) {
        this.setState({
            quickProductUnitOfMeasure: unit
        })
    }

    handleQuickProductMeasureChange(measure) {
        this.setState({
            quickProductMeasure: measure
        })
    }

    handleQuickCreateFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                quickProductImages: images,
                quickProductImageIds: images.map(i => i.id),
            })
        } else {
            this.setState({
                quickProductImages: [],
                quickProductImageIds: [],
            })
        }
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let newState = {
            [target.name]: value
        }
        if (target.name === 'itemStatus' && target.value === 'extra-fee') {
            newState.measure = 0
        }
        if (target.name === 'billingMethod') {
            switch (target.value) {
                case 'one-time':
                    newState.unitPrice = this.state.defaultUnitPrice
                    newState.unitCost = this.state.defaultUnitCost
                    break
                case 'monthly':
                    newState.unitPrice = this.state.monthlyUnitPrice
                    newState.unitCost = this.state.monthlyUnitCost
                    break
                case 'yearly':
                    newState.unitPrice = this.state.yearlyUnitPrice
                    newState.unitCost = this.state.yearlyUnitCost
                    break
            }
        }
        this.setState(newState)
    }

    validateAllForms() {
        var forms = document.getElementsByClassName('needs-validation add-item-form');
        var areAllFormsFormValid = true
        Array.prototype.filter.call(forms, function (form) {
            var checkCurrentForm = form.checkValidity()
            if (areAllFormsFormValid === true && checkCurrentForm === false) {
                areAllFormsFormValid = checkCurrentForm
            }
            form.classList.add('was-validated');
        });

        return areAllFormsFormValid
    }

    validateQuickCreateForm() {
        let form = document.getElementById("quick-create-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    // priceForMargin is used in the specific case where we use getPrice for margin calculation
    // If the line item has a discount, we want to use the calculatedPrice instead for margin calculation
    getPrice(item, priceForMargin) {
        const calculatedPrice = item.attributes.calculatedUnitPrice
        const unitPrice = !item.attributes.isTaxInclusive ? item.attributes.unitPrice : item.attributes.unitPriceInclusive

        if (item.attributes.priceLevelId) {
            const productPrices = item.attributes.itemObject?.attributes.productPrices || []
            const priceLevel = productPrices?.find(p => p.attributes.priceLevelId === item.attributes.priceLevelId)

            if (priceLevel) {
                return priceLevel.attributes.price
            }
        }

        let unitPriceEqualFromCalculated = Number(calculatedPrice) !== 0 &&
            Number(calculatedPrice) === Number(unitPrice)
        let notHasDiscount = item.attributes.discountValue && Number(item.attributes.discountValue) === 0
        if (!unitPriceEqualFromCalculated && (notHasDiscount || priceForMargin)) {
            return calculatedPrice
        }
        return unitPrice
    }

    loadQuoteItem(itemId) {
        let endPoint = `/${this.mainObjectItem}/${itemId}`
        if (this.props.mainObject === PRICING_TABLES) {
            endPoint = `/pricing-tables/rows/${itemId}`
        }

        AppContext.getApiClient().get(endPoint).then((response) => {
            let productId = response.attributes.itemObject.id
            let matrixItem = null
            let configurations = []
            if (response.attributes.itemObject.attributes.type === "assembly") {
                configurations = response.attributes.configurations.map(conf => {
                    return {
                        additionalUnitPrice: conf.attributes.additionalUnitPrice,
                        additionalUnitCost: conf.attributes.additionalUnitCost,
                        measure: conf.attributes.measure,
                        partChoiceId: conf.attributes.partChoice.id,
                        partId: conf.attributes.partChoice.attributes.part.id,
                    }
                })
            }
            if (response.attributes.itemObject.attributes.type === "matrix-item") {
                AppContext.getApiClient().get('/products/' + response.attributes.itemObject.id + '/matrix').then((res) => {
                    productId = res.attributes.matrix.attributes.parentProductId
                    const itemsFound = res.attributes.matrix.attributes.items.filter(item => {
                        return item.attributes.productId === response.attributes.itemObject.id
                    })
                    if (itemsFound.length > 0) {
                        matrixItem = itemsFound[0]
                        this.productSelect(productId)
                        this.setState({
                            matrixItem: matrixItem,
                        })
                    }
                })

            }
            const calculatorValues = {}
            for (let index in response.attributes.calculatorValues) {
                const val = response.attributes.calculatorValues[index]
                calculatorValues[val.attributes.variableName] = val.attributes.value
            }

            let itemCustomAttributes
            const itemCustomAttributeValues = response.attributes.itemCustomAttributeValues
            const itemCustomAttributeDefinitions = response.attributes.itemCustomAttributeDefinitions
            itemCustomAttributes = matchCustomDefnToValue(itemCustomAttributeValues, itemCustomAttributeDefinitions, response.id)

            const unitPrice = this.getPrice(response, false)
            const newState = {
                measure: response.attributes.measure,
                additionalMeasure: response.attributes.additionalMeasure,
                taxable: response.attributes.taxable,
                feeApplicable: response.attributes.feeApplicable,
                itemStatus: response.attributes.type,
                groupId: response.attributes.groupId,
                unitPrice: unitPrice,
                unitCost: response.attributes.unitCost,
                billingMethod: response.attributes.billingMethod,
                commitmentDuration: response.attributes.commitmentDuration,
                calculatorValues: calculatorValues,
                selectedPriceLevelId: response.attributes.priceLevelId,
                itemId: response.id,
                quoteItem: response,
                matrixItem: matrixItem,
                initialAssemblyConfiguration: configurations,
                defaultUnitPrice: response.attributes.itemObject.attributes.defaultUnitPrice,
                monthlyUnitPrice: response.attributes.itemObject.attributes.monthlyUnitPrice,
                yearlyUnitPrice: response.attributes.itemObject.attributes.yearlyUnitPrice,
                defaultUnitCost: response.attributes.itemObject.attributes.defaultUnitCost,
                monthlyUnitCost: response.attributes.itemObject.attributes.monthlyUnitCost,
                yearlyUnitCost: response.attributes.itemObject.attributes.yearlyUnitCost,
                itemCustomAttributes: itemCustomAttributes,
                serialNumbers: response.attributes.serialNumbers?.map(sn => sn.attributes.serial) ?? [],
                serialNumbersWithHistory: response.attributes.serialNumbers ?? null,
                referenceRowId: response.attributes.referenceRowId
            }

            if (response.attributes.itemObject.type === "quick-products") {
                newState.quickProductTitle = response.attributes.itemObject.attributes.title
                newState.quickProductShortDescription = response.attributes.itemObject.attributes.shortDescription
                newState.quickProductLongDescription = response.attributes.itemObject.attributes.longDescription
                newState.quickProductUnitOfMeasure = response.attributes.itemObject.attributes.unitOfMeasure
                newState.quickProductUnitPrice = response.attributes.itemObject.attributes.defaultUnitPrice
                newState.quickProductUnitCost = response.attributes.itemObject.attributes.defaultUnitCost
                newState.quickProductBillingMethod = response.attributes.itemObject.attributes.billingMethod
                newState.quickProductMeasure = response.attributes.measure
                newState.quickProductImages = response.attributes.itemObject.attributes.images
                newState.quickProductImageIds = response.attributes.itemObject.attributes.images.map(im => im.id)
                EventBus.dispatch(EventBus.TopicUploaderImagesLoaded, {
                    images: response.attributes.itemObject.attributes.imageIds,
                })
                this.setState(newState)
                $('#quickCreateProductModal').modal('show')
            } else {
                this.setState(newState)
                this.productSelect(productId, (item) => {
                    this.chooseProductLineButton(item.id)
                })
                $('#configureQuoteItemModal').modal('show')
            }
        })
    }

    customAttribute(definitionId, label, value, rowId) {
        return {
            customAttributeDefinitionId: definitionId,
            label: label,
            value: value,
            rowId: rowId,
        }
    }

    focusAndSelect() {
        setTimeout(() => {
            if (document.getElementById('searchKeywords')) {
                document.getElementById('searchKeywords').focus()
                document.getElementById('searchKeywords').select()
            }
        }, 200)
    }

    searchProductIds() {
        let fields = [
            'title',
            'titleKeyword',
            'titleAnalyzed',
            'titleSort',
            'sku',
            'skuKeyword',
            'manufacturerSkuText',
            'manufacturerSkuKeyword',
            'skuText',
            'upc',
            'ean',
            'barcode',
        ]
        if (Settings.get(SupportedSettings.ShowShortDescriptionInListing)) {
            fields = fields.concat([
                'shortDescription',
                'shortDescriptionKeyword',
                'shortDescriptionAnalyzed',
                'shortDescriptionSort',
            ])
        }
        let postData = {
            keywords: GlobalHelper.formatSearchKeywords(this.state.searchKeywords),
            objects: ['products'],
            fields: fields,
            pageSize: 1000,
            activePage: 1,
            sortByField: 'titleSort',
            sortAsc: true,
            filters: {
                type: this.state.allowedProductTypes
            }
        }
        if (this.state.searchLabelIds.length > 0) {
            postData.filters.labelIds = this.state.searchLabelIds
        }

        AppContext.getApiClient().post('/listing/search', postData).then(res => {
            if (!res.error) {
                this.setState({
                    currentProductIds: res.data.map(p => p.id),
                })
            }
        })
    }

    refreshSearch() {
        this.setState({
            isLoading: true
        })
        let fields = [
            'title',
            'titleKeyword',
            'titleAnalyzed',
            'titleSort',
            'sku',
            'skuKeyword',
            'manufacturerSkuText',
            'manufacturerSkuKeyword',
            'skuText',
            'upc',
            'ean',
            'barcode',
        ]
        if (Settings.get(SupportedSettings.ShowShortDescriptionInListing)) {
            fields = fields.concat([
                'shortDescription',
                'shortDescriptionKeyword',
                'shortDescriptionAnalyzed',
                'shortDescriptionSort',
            ])
        }
        let postData = {
            keywords: GlobalHelper.formatSearchKeywords(this.state.searchKeywords),
            objects: ['products'],
            fields: fields,
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: 'titleSort',
            sortAsc: true,
            filters: {
                type: this.state.allowedProductTypes
            },
            lightResult: true
        }

        if (this.state.stockDocument != null) {
            postData.filters.isNonInventory = false
            postData.filters.inventoryTracking = true
            postData.filters.type = ["matrix-parent", "single"]
        }

        if (this.state.searchLabelIds.length > 0) {
            postData.filters.labelIds = this.state.searchLabelIds
        }

        if (this.state.selectedPriceLevelId) {
            postData.filters.priceLevelId = this.state.selectedPriceLevelId
        }


        Promise.all([
            this.state.selectedPriceLevelId ? SearchService.productListingSearchWithPriceLevels(postData) : SearchService.listingSearch(postData),
            GlobalHelper.saveListingPreferences(
                this.preferenceType(),
                this.state.activePage,
                this.state.pageSize,
                this.state.searchKeywords,
                "",
                false,
                false,
                "",
                false,
                {
                    searchLabelIds: this.state.searchLabelIds,
                },
            )
        ]).then(res => {
            const r = res[0]
            if (!isError(r)) {
                if (r.data.length > 0 && GlobalHelper.isBarcode(this.state.searchKeywords) && this.state.enterKeyPressed) {
                    this.directAdd(r.data[0]).then(_ => {
                        this.setState({
                            searchKeywords: '',
                            enterKeyPressed: false,
                        }, () => {
                            this.refreshSearch()
                        })
                    })
                } else {
                    this.setState({
                        products: r.data,
                        totalItemsCount: r.metadata.totalItemsCount,
                        isLoading: false,
                        enterKeyPressed: false,
                    })
                }
            }
        })
    }

    directAdd(product) {
        this.setState({
            title: product.title
        })
        return this.multiCreateProduct([product.id], '').then(_ => {
            this.quit(true)
        })
    }

    showNotification(message) {
        EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
            message: message
        })
    }

    quickCreateProduct(event) {
        $('#addPricingRowModal').modal('hide')
        $('#quickCreateProductModal').modal('show')
        this.setState({
            billingMethod: 'one-time'
        })
        event.preventDefault()
    }

    backToChooseProduct(event) {
        $('#configureQuoteItemModal').modal('hide')
        $('#addPricingRowModal').modal('show')
        event.preventDefault()
        if (this.state.currentProductIdsIndex > 0) {
            this.setState({
                currentProductIds: this.state.currentProductIds.slice(this.state.currentProductIdsIndex, this.state.currentProductIds.length),
                currentProductIdsIndex: 0,
                selectedPriceLevelId: this.state.selectedPriceLevelId,
            })
            this.quit(true, false)
        } else {
            this.setState({
                measure: "1",
                serialNumbers: [],
                serialNumbersUpdated: false,
            })
        }
    }

    closeModals(event) {
        $('#addPricingRowModal').modal('hide')
        $('#configureQuoteItemModal').modal('hide')
        $('#quickCreateProductModal').modal('hide')
        this.props.onClose()

        event.preventDefault()
    }

    closeConfigurationModal() {
        this.props.onClose()
    }

    addBundleProduct() {
        this.addProductOnCreateQuoteItem(this.state.measure)
    }

    itemCustomAttributesOnChangeHandler(updatedDefs) {
        event.preventDefault()
        this.setState({
            itemCustomAttributes: updatedDefs,
            isItemCustomAttributesUpdated: true,
        })
    }

    shouldDisableUnitCost() {
        if (this.mainObject === PRICING_TABLES && this.state.stockDocument) {
            const direction = this.state.stockDocument.definition?.attributes?.direction
            return [INVENTORY_STOCK_DIRECTION.OUT].includes(direction)
        }
        return [PRICING_TABLES].includes(this.mainObject)
    }

    renderItemCustomAttributesFields(product, itemCustomAttributes) {
        if (product.attributes.customAttributeDefinitions) {
            return itemCustomAttributes.map((customAttributeValue) => {
                return (<div className="form-group form-row">
                    <label className={"col-5 col-form-label text-align-right "}>
                        {customAttributeValue.label}
                    </label>
                    <div className="col-7">
                        <CustomAttributeWrapper
                            definitionId={customAttributeValue.customAttributeDefinitionId}
                            value={customAttributeValue.textValue || customAttributeValue.selectValue}
                            itemCustomAttributesDefinitions={product.attributes.customAttributeDefinitions}
                            itemCustomAttributesValues={itemCustomAttributes}
                            onChange={(updatedCustomAttributes) => this.itemCustomAttributesOnChangeHandler(updatedCustomAttributes)}
                        />
                    </div>
                </div>)
            })
        }
        return <></>

    }

    renderBillingMethods() {
        return <div>
            {this.state.billingMethods.map((m, index) => {
                return <div key={index} className="custom-control custom-radio">
                    <input type="radio"
                        id={m}
                        name="billingMethod"
                        value={m}
                        checked={this.state.billingMethod === m}
                        onChange={this.handleFormChange}
                        className="custom-control-input" />
                    <label className="custom-control-label" htmlFor={m}>
                        <BillingMethodLabel value={m} />
                    </label>
                </div>
            })}
        </div>
    }

    deleteItem(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/' + this.mainObjectItem + '/' + this.state.itemId + `?mainObjectId=${this.objectId}`).then((response) => {
            if (response.id) {
                this.quit()
            }
        })
    }

    isBundle() {
        return this.state.product && this.state.product.attributes.type === PRODUCT_TYPE.BUNDLE
    }

    isMatrix() {
        return this.state.product && this.state.product.attributes.type === "matrix-parent"
    }

    preferenceType() {
        if (this.mainObject === 'price-lists') {
            return 'listingAddItemPriceLists'
        }
        if (this.mainObject === 'invoices') {
            return 'listingAddItemInvoices'
        }
        return 'listingAddItemQuotes'
    }

    getTaxRate() {
        let taxRate = 0

        // Try to get the tax rate from the itemTax attributes
        if (this.props.itemTax?.attributes?.totalRate) {
            taxRate = parseFloat(this.props.itemTax.attributes.totalRate);
        } else {
            // If not found, try to find the tax rate from the totals based on billing method
            const total = this.props.totals.find(total => total.attributes.billingMethod === this.state.billingMethod);
            if (total?.attributes?.tax?.attributes?.totalRate) {
                taxRate = parseFloat(total.attributes.tax.attributes.totalRate)
            }
        }
        return taxRate
    }

    getUnitMargin() {
        const { unitCost, product, quoteItem } = this.state
        const unitPrice = quoteItem ? this.getPrice(quoteItem, true) : this.state.unitPrice

        // Determine if the product is tax exempt. It is considered tax exempt if:
        // 1. The product is tax exempt
        // 2. The line item is not taxable
        const isTaxExempt = !!((product?.attributes?.taxExempt) || (quoteItem?.attributes?.taxable === false))
        const isItemTaxInclusive = !!(AppContext.getAccount()?.attributes?.isTaxInclusive && unitPrice && this.props.totals)
        if (isItemTaxInclusive && !isTaxExempt) {
            const taxRate = this.getTaxRate()
            if (taxRate > 0) {
                const priceBeforeTax = unitPrice / (1 + taxRate / 100)
                const taxAmount = unitPrice - priceBeforeTax
                const basePrice = unitPrice - taxAmount
                return (basePrice - unitCost).toFixed(2)
            }
        }
        return parseFloat(unitPrice - (unitCost ?? 0)).toFixed(2)
    }

    getUnitMarginRatio() {
        const { unitPrice, product, quoteItem } = this.state

        const taxRate = this.getTaxRate()
        // Determine if the product is tax exempt. It is considered tax exempt if:
        // 1. The product is tax exempt
        // 2. The line item is not taxable
        const isTaxExempt = !!((product?.attributes?.taxExempt) || (quoteItem?.attributes?.taxable === false))
        if (AppContext.getAccount()?.attributes?.isTaxInclusive && taxRate > 0 && !isTaxExempt) {
            const priceBeforeTax = unitPrice / (1 + taxRate / 100)
            return (unitPrice && parseFloat(unitPrice) > 0) ? this.getUnitMargin() / parseFloat(priceBeforeTax).toFixed(2) : 0
        }

        return (unitPrice && parseFloat(unitPrice) > 0) ?
            (this.getUnitMargin() / parseFloat(unitPrice)) : 0
    }

    isChoosingProductFromCurrentProductIds() {
        return this.state.currentProductIds.length > 0 && this.state.currentProductIds[this.state.currentProductIdsIndex] === this.state.selectedProductId
    }

    selectableModalSearchProductList() {
        return this.state.searchLabelIds.length > 0 || this.state.searchKeywords !== ''
    }

    onSerialNumberChange = (serialNumbers) => {
        this.setState({
            serialNumbersUpdated: true,
            serialNumbers: serialNumbers
        });
    }

    validateSerialNumberHistory = () => {
        return this.props.mainObject === PRICING_TABLES
            && hasHistoryWithRowID(this.state.referenceRowId, this.state.serialNumbersWithHistory)
    }

    allowNegativeQuantity() {
        if (this.mainObject == 'orders') {
            return false
        }
        if (this.state.stockDocument && !(this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN_OUT)) {
            return false
        }
        return true
    }

    getSelectedMatrixVariantCost() {
        const selectedVariant = this.state.matrixSelectedIds[0]
        const matrixItem = this.state.matrixActiveItems.find(item => item.attributes.productId === selectedVariant.variantId)
        return Number(matrixItem?.attributes.product.attributes.defaultUnitCost ?? 0)
    }

    renderConfigureQmInventory() {
        let inventoryQuantity
        let location = this.state.location
        let inventoryLocationId = ""
        let inventoryLocationName = ""

        if (this.props.documentInventoryLocations.length > 0 && location && this.state.product) {
            const inventoryLocation = getInventoryLocationFromLocation(location.id, this.props.documentInventoryLocations)
            if (inventoryLocation !== null) {
                inventoryLocationId = inventoryLocation.id
                inventoryLocationName = inventoryLocation.name
            }


            if (inventoryLocationId !== "") {
                inventoryQuantity = getQuantityAvailableByInventoryLocationId(this.state.product, inventoryLocationId)
            }

            if (inventoryLocationName !== "" && inventoryQuantity !== null) {
                return (
                    <div className="col-sm-12 col-md-6 d-none d-md-block pl-0">
                        <div className="justify-content-between d-flex">
                            <em>
                                <Icon value={"map-marker-alt"} className={"mr-2"} />
                                {inventoryLocationName}
                            </em>
                            {inventoryQuantity}
                        </div>
                    </div>
                )
            }
        }

        return <></>
    }

    renderStockDocumentInventory() {
        let inventoryQuantity
        let inventoryLocationId = this.state.stockDocument.inventoryLocationId
        let inventoryLocationName = this.state.stockDocument.inventoryLocation?.attributes?.name
        if (inventoryLocationId !== "") {
            if (this.isMatrix()) {
                let filteredItems = this.state.matrixSelectedIds.length == 0 ?
                    this.state.matrixActiveItems :
                    this.state.matrixActiveItems.filter(i => {
                        let variantIds = this.state.matrixSelectedIds.map(v => v.variantId)
                        return variantIds.includes(i.attributes.product.id)
                    })
                inventoryQuantity = filteredItems.reduce((total, item) => {
                    return total + getQuantityAvailableByInventoryLocationId(item.attributes.product, inventoryLocationId)
                }, 0)
            } else {
                inventoryQuantity = getQuantityAvailableByInventoryLocationId(this.state.product, inventoryLocationId)
            }
        }

        if (inventoryLocationName !== "" && inventoryQuantity !== null) {
            return (
                <div className="col-sm-12 col-md-6 d-none d-md-block">
                    <div className="justify-content-between d-flex">
                        <em>
                            <Icon value={"map-marker-alt"} className={"mr-2"} />
                            {inventoryLocationName}
                        </em>
                        {inventoryQuantity}
                    </div>
                </div>
            )
        }

        return <></>
    }

    render() {
        let matrixSelection = ''
        if (this.state.isProductLoading) {
            matrixSelection = <LoadingSpinner />
        } else if (this.isMatrix() && this.state.matrixActiveItems.length === 0) {
            matrixSelection = <div className="form-group form-row d-flex justify-content-end text-danger" style={{ "textAlign": "end" }}>
                <div>
                    <FormattedMessage
                        id="pricing.add_item_modal.matrix_options_select"
                        defaultMessage="Currently there are no options available for this product matrix. {br} You can add/edit options on the product edit page."
                        values={{ br: <br /> }}
                    />
                </div>
            </div>
        } else if (this.isMatrix() && this.state.matrixActiveItems.length > 1) {

            matrixSelection = <MatrixSelection
                product={new Product(this.state.product)}
                onMatrixItemSelect={this.matrixItemSelect}
                onSelectedOptionIdsChange={(ids) => {
                    this.setState({
                        matrixSelectedIds: ids,
                    })
                }}
                selectedMatrixItem={this.state.matrixItem}
            />
        }
        let assemblyPart = ''
        if (this.state.product && this.state.product.attributes.type === "assembly") {
            const hasCalculator = this.state.product.attributes.calculator != null
            assemblyPart = <ModalSearchAssemblyParts
                hasCalculator={hasCalculator}
                onChange={this.assemblySelectionChange}
                assembly={this.state.product.attributes.assembly}
                calculatorResults={this.state.calculatorResults}
                initialAssemblyConfiguration={this.state.initialAssemblyConfiguration}
            />

        }
        let calculatorInput = ''
        if (this.state.product && this.state.product.attributes.calculator) {
            calculatorInput = <ModalSearchCalculatorInput
                value={this.state.product.attributes.calculator}
                vars={this.state.calculatorValues}
                assembly={this.state.product.attributes.assembly}
                onChange={this.handleCalculatorChange}
            />

        }

        let deleteBtn = ''
        let saveBtnTxt = <FormattedMessage
            id="quote.add_item_modal.configure.add_product_btn"
            defaultMessage="Add product"
        />
        if (this.state.itemId) {
            deleteBtn =
                <ActionButton type="button" onClick={this.deleteItem} className="btn btn-danger mb-2 mb-lg-0 ml-md-2 ">
                    <FormattedMessage
                        id="quote.add_item_modal.delete_btn"
                        defaultMessage="Delete"
                    />
                </ActionButton>
            saveBtnTxt = <FormattedMessage
                id="quote.add_item_modal.configure.save_btn"
                defaultMessage="Save"
            />
        }

        let billingMethodSelection = ''
        if (GlobalHelper.IsFeatureFlagEnabled("billingMethods")) {
            if (this.state.billingMethods.length > 1 && !this.state.stockDocument) {
                billingMethodSelection = <div className="col-12">
                    <div className="form-group form-row">
                        <label className="col-5 col-form-label text-align-right">
                            <FormattedMessage
                                id="quote.add_item_modal.configure.billing_method_label"
                                defaultMessage="Billing method"
                            />
                        </label>
                        <div className="col-7">
                            {this.renderBillingMethods()}
                        </div>
                    </div>
                </div>
            }
        }

        let quickProductBtn = ''
        if (!this.state.hideQuickProduct && Guard.isAuthorized(Permissions.QuickCreate)) {
            quickProductBtn =
                <ActionButton className="btn btn-outline-primary"
                    style={{ width: '160px' }}
                    onClick={this.quickCreateProduct}>
                    <FormattedMessage
                        id="quote.add_item_modal.quick_create_btn"
                        defaultMessage="Quick Create"
                    />
                </ActionButton>
        }

        const image = this.state.images.length > 0 ?
            <Image imageId={this.state.images[0].id} size="very-small" className={"mr-2"} /> : ''

        let addToCatalogCheckBox = <div className="form-group row pl-3 mb-1">
            <label className="col-2 col-form-label text-align-right px-2" />
            <div className="col-10 custom-control custom-checkbox pl-4">
                <input
                    type="checkbox"
                    className="custom-control-input"
                    id="quickAddToCatalog"
                    name="quickAddToCatalog"
                    onChange={this.handleFormChange}
                    checked={this.state.quickAddToCatalog}
                />
                <label className="custom-control-label" htmlFor="quickAddToCatalog">
                    <FormattedMessage
                        id="quote.quick_create_modal.add_to_catalog_label"
                        defaultMessage="Save to my product catalog"
                    />
                </label>
            </div>
        </div>

        if (this.state.itemId) {
            addToCatalogCheckBox = ''
        }

        let list = <ModalSearchProductList
            addProductCallback={(productId) => this.chooseProductLineButton(productId)}
            onProductClick={(productId) => {
                this.productSelect(productId, (item) => {
                    let itemId = item.id
                    if (item.attributes?.type == "matrix-parent" && item.attributes?.matrix?.attributes?.items?.length == 1) {
                        let matrixItemId = item.attributes.matrix.attributes.items[0].attributes?.productId || ""
                        if (matrixItemId != "") {
                            itemId = matrixItemId
                        }

                    }
                    this.chooseProductLineButton(itemId)
                })
            }}
            onProductSelectAll={allSelected => {
                if (!allSelected) {
                    this.setState({
                        currentProductIds: [],
                        currentProductIdsIndex: 0,
                    })
                } else {
                    this.searchProductIds()
                }
            }}
            onProductPageSelect={productIds => {
                this.setState({
                    currentProductIds: productIds,
                    currentProductIdsIndex: 0,
                })
            }}
            onProductSelect={productId => {
                this.setState({
                    currentProductIds: !this.state.currentProductIds.includes(productId) ?
                        this.state.currentProductIds.concat([productId]) : this.state.currentProductIds.filter(pId => pId !== productId),
                })
            }}
            onAddMultipleProducts={(productIds, groupId) => {
                if (productIds && productIds.length > 0) {
                    this.setState({
                        currentProductIds: productIds,
                    })
                    this.productSelect(productIds[0])
                    this.chooseProductLineButton(productIds[0])
                }
            }}
            products={this.state.products}
            location={this.state.location}
            selectable={this.selectableModalSearchProductList()}
            totalItemsCount={this.state.totalItemsCount}
            pageSize={this.state.pageSize}
            currentProductIds={this.state.currentProductIds}
            isPriceLevelSelected={!!this.state.selectedPriceLevelId}
            stockDocument={this.state.stockDocument}
        />

        if (this.state.isLoading) {
            list = <LoadingSpinner />
        } else if (this.state.products.length === 0 && GlobalHelper.hasAtLeastOneListingFilter(this.preferenceType())) {
            list = <NoResult onClearFilters={this.handleClearFilters} noContainer={true} />
        }

        let selectionContent = <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-12">
                    <DebounceInput
                        onKeyPress={e => {
                            const code = e.keyCode || e.charCode
                            let state = {
                                loading: true
                            }
                            if (code === 13) {
                                e.preventDefault()
                                state.enterKeyPressed = true
                            }
                            this.setState(state)
                        }}
                        minLength={0}
                        debounceTimeout={500}
                        onChange={this.handleSearchChange}
                        autoComplete="off"
                        name="searchKeywords"
                        value={this.state.searchKeywords}
                        id="searchKeywords"
                        type="text"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage(messages["search_product_placeholder"])}
                    />
                </div>
                <div className="col-md-6 col-12">
                    <LabelSelect
                        placeholder={this.props.intl.formatMessage(messages["label_filter_placeholder"])}
                        value={this.state.searchLabelIds}
                        onChange={this.onLabelSelectChange}
                        multi={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {list}
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Pagination
                        showPageSize={true}
                        onPageSizeChange={this.handlePageSizeChange}
                        className={'px-3 pt-2'}
                        activePage={this.state.activePage}
                        pageSize={this.state.pageSize}
                        totalItemsCount={this.state.totalItemsCount}
                        onChange={this.handlePageChange}
                    />
                </div>
            </div>
        </div>
        if (this.state.products.length === 0 && !GlobalHelper.hasAtLeastOneListingFilter(this.preferenceType()) && !this.state.isLoading) {
            quickProductBtn = ''
            addToCatalogCheckBox = ''
            selectionContent = <div className="container-fluid">
                <div className="w-100 text-center p-4">
                    <strong>
                        <FormattedMessage
                            id="quote.add_item_modal.catalog_empty_title"
                            defaultMessage="Your catalog is empty..."
                        />
                    </strong>
                    <br />
                    <FormattedMessage
                        id="quote.add_item_modal.catalog_empty_description"
                        defaultMessage="Create a new product so you can add it to your quote."
                    />
                    <br />
                    <br />
                    {!this.state.stockDocument &&
                        <ActionButton type="button" className="btn btn-primary" onClick={this.quickCreateProduct}>
                            <Icon value={"plus-circle"} />
                            <FormattedMessage
                                id="quote.add_item_modal.create_product_btn"
                                defaultMessage="Create a new product"
                            />
                        </ActionButton>
                    }
                </div>
            </div>
        }

        const productLightspeedExternalLink = this.state.product ? this.state.product.attributes.externalLinks.find(link =>
            link.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL) : null

        const groups = this.state.groups.filter(g => [this.state.billingMethod, ""].includes(g.attributes.billingMethod))

        return (<>
            <div>
                {/************** Product selection Modal ***************/}
                <div className="modal"
                    id="addPricingRowModal"
                    role="dialog"
                    aria-labelledby="addPricingRowModalLabel"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addPricingRowModalLabel">
                                    {!this.state.stockDocument ?
                                        <FormattedMessage
                                            id="quote.add_item_modal.title"
                                            defaultMessage="Add a product to the quote"
                                        /> : <FormattedMessage
                                            id="quote.add_item_modal.title_products"
                                            defaultMessage="Add a product"
                                        />}
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {selectionContent}
                            </div>
                            <div className="modal-footer">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between">
                                        <Col sm="4">
                                            <PriceLevelSelect
                                                selectedValue={this.state.selectedPriceLevelId}
                                                onChange={(priceLevelId) => {
                                                    this.setState({ selectedPriceLevelId: priceLevelId }, () => this.refreshSearch())
                                                }}
                                            />
                                        </Col>
                                        <div className="ml-auto">
                                            <Form.Group>
                                                <Button
                                                    className="mr-2"
                                                    style={{ width: '160px' }}
                                                    variant="secondary"
                                                    onClick={this.closeModals}>
                                                    <FormattedMessage
                                                        id="quote.add_item_modal.close_btn"
                                                        defaultMessage="Close"
                                                    />
                                                </Button>
                                                {!this.state.stockDocument &&
                                                    <>
                                                        {quickProductBtn}
                                                    </>}
                                                {this.state.currentProductIds.length > 0 &&
                                                    <Button
                                                        className="ml-2"
                                                        style={{ width: '160px' }}
                                                        onClick={(e) => {
                                                            this.productSelect(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                            this.chooseProductLineButton(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                        }}>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.add_selected_btn"
                                                            defaultMessage="Add selected items"
                                                            values={{
                                                                numberOfItems: this.state.currentProductIds.slice(this.state.currentProductIdsIndex, this.state.currentProductIds.length).length,
                                                            }}
                                                        />
                                                    </Button>
                                                }

                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/************** Configure Modal ***************/}
                <div className="modal"
                    id="configureQuoteItemModal"
                    role="dialog"
                    aria-labelledby="configureQuoteItemModal"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <form onSubmit={this.addProduct} className="needs-validation add-item-form" noValidate>
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className="row w-100 d-flex align-items-center">
                                        <div
                                            className={'d-flex align-items-center ' + (this.isChoosingProductFromCurrentProductIds() ? 'col-10' : 'col-12')}>
                                            <div className="d-none d-md-block">
                                                {image}
                                            </div>
                                            <h5 className="modal-title d-none d-md-block" id="addPricingRowModalLabel">
                                                <div className="d-inline-block">
                                                    <div>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.title"
                                                            defaultMessage="Configure: {productTitle}"
                                                            values={{ productTitle: this.state.title }}
                                                        />
                                                    </div>
                                                    {this.state.product &&
                                                        <small>
                                                            {this.state.product.attributes.sku}
                                                        </small>
                                                    }
                                                </div>
                                            </h5>
                                            <h5 className="modal-title d-block d-md-none" id="addPricingRowModalLabel">
                                                <div className="d-inline-block">
                                                    <div>
                                                        {this.state.title}
                                                    </div>
                                                    {this.state.product &&
                                                        <small>
                                                            {this.state.product.attributes.sku}
                                                        </small>
                                                    }
                                                </div>
                                            </h5>
                                        </div>
                                        {this.isChoosingProductFromCurrentProductIds() &&
                                            <div className="col-2 d-flex justify-content-end">
                                                <FormattedMessage
                                                    id="quote.add_item_modal.bulk_progress"
                                                    defaultMessage="Item {from} / {to}"
                                                    values={{
                                                        from: this.state.currentProductIdsIndex + 1,
                                                        to: this.state.currentProductIds.length
                                                    }}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <button type="button" className="close" onClick={this.closeModals}
                                        aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.isProductLoading ?
                                        <LoadingSpinner /> :
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-12">
                                                    {calculatorInput}
                                                    {assemblyPart}
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-7 d-none d-md-block">
                                                            <div className="w-100 mb-1">
                                                                <em>
                                                                    {this.state.shortDescription.split('\n').map((c, key) =>
                                                                        <p key={key} className={'m-0 add-item-trunc-long-text'}>{c}</p>)}
                                                                </em>
                                                                {this.state.product && this.state.inventoryEnabled && AppContext.isMultiLocation() &&
                                                                    !this.state.product.attributes.isNonInventory &&
                                                                    <div>
                                                                        <div
                                                                            className={'row ' + (this.state.shortDescription ? 'mt-4' : 'mt-2')}>
                                                                            <div
                                                                                className="col-sm-12 col-md-6 d-none d-md-block">
                                                                                {
                                                                                    this.state.inventoryCollapseExpanded ?
                                                                                        <div>
                                                                                            {
                                                                                                GlobalHelper.getRemoteQuantitesOnHandByLocation(this.state.product, this.state.location).map(location => {
                                                                                                    return <div
                                                                                                        className="justify-content-between d-flex">
                                                                                                        <em> <Icon
                                                                                                            value={location.isCurrentLocation ? "map-marker-alt" : "store-alt"}
                                                                                                            className={"mr-2"} />
                                                                                                            {location.name}
                                                                                                        </em>
                                                                                                        <em>{location.quantityOnHand}</em>

                                                                                                    </div>
                                                                                                })
                                                                                            }
                                                                                        </div>
                                                                                        : (this.state.location ? <div
                                                                                            className="justify-content-between d-flex">
                                                                                            <em> <Icon value={"map-marker-alt"}
                                                                                                className={"mr-2"} />
                                                                                                {this.state.location.attributes.name}:</em>
                                                                                            <em>{GlobalHelper.getQuantityOnHandFromFullProduct(this.state.product, this.state.location)}</em>
                                                                                        </div> :
                                                                                            (AppContext.getUserLoggedIn().attributes.location ?
                                                                                                <div
                                                                                                    className="justify-content-between d-flex">
                                                                                                    <em> <Icon
                                                                                                        value={"map-marker-alt"}
                                                                                                        className={"mr-2"} />
                                                                                                        {AppContext.getUserLoggedIn().attributes.location.attributes.name}:</em>
                                                                                                    <em>{GlobalHelper.getQuantityOnHandFromFullProduct(this.state.product)}</em>
                                                                                                </div> : ''))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="mt-2">
                                                                            <a href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault()
                                                                                    this.setState({ inventoryCollapseExpanded: !this.state.inventoryCollapseExpanded })
                                                                                }}>
                                                                                {this.state.inventoryCollapseExpanded ?
                                                                                    <FormattedMessage
                                                                                        id="quote.add_item_modal.hide_remote_inventory_label"
                                                                                        defaultMessage="Hide remote inventory"
                                                                                    /> : <FormattedMessage
                                                                                        id="quote.add_item_modal.show_remote_inventory_label"
                                                                                        defaultMessage="Show remote inventory"
                                                                                    />}
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                }

                                                                {this.state.stockDocument && this.state.product && this.renderStockDocumentInventory()}
                                                                {AppContext.isInventoryEnabled() && !this.state.stockDocument && this.renderConfigureQmInventory()}
                                                            </div>
                                                            {this.isBundle() &&
                                                                <BundleOptionsDisplay product={new Product(this.state.product)} />
                                                            }
                                                            {productLightspeedExternalLink && !this.state.stockDocument && !AppContext.isInventoryEnabled() &&
                                                                <div className="mt-3">
                                                                    <small className="d-block mt-2">
                                                                        <a className="btn btn-light border border-secondary"
                                                                            href={Integrations.getProductExternalUrl(productLightspeedExternalLink)}
                                                                            target="_blank" rel='noopener noreferrer'>
                                                                            <Icon value="external-link-alt"
                                                                                className={"mr-2"} />
                                                                            {Integrations.getIntegrationLogoImage(productLightspeedExternalLink.attributes.integrationKey, 80, 25)}
                                                                        </a>
                                                                    </small>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="col-sm-12 col-md-5">
                                                            <div className="form-group form-row">
                                                                <label className="col-5 col-form-label text-md-right">
                                                                    <FormattedMessage
                                                                        id="quote.add_item_modal.configure.quantity_label"
                                                                        defaultMessage="Quantity"
                                                                    />
                                                                </label>
                                                                <div className="col-7">
                                                                    <InputUnitOfMeasure
                                                                        name="measure"
                                                                        value={this.state.measure}
                                                                        unit={this.state.unitOfMeasure}
                                                                        onChange={this.handleMeasureChange}
                                                                        allowNegative={this.allowNegativeQuantity()}
                                                                        id={'measure'}
                                                                        disabled={this.isBundle() ? true : false}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {this.state.additionalUnitOfMeasure &&
                                                                <div className="form-group form-row">
                                                                    <label
                                                                        className="col-5 col-form-label text-md-right">
                                                                        <FormattedMessage
                                                                            id="quote.add_item_modal.configure.quantity_label"
                                                                            defaultMessage="Quantity"
                                                                        />
                                                                    </label>
                                                                    <div className="col-7">
                                                                        <InputUnitOfMeasure
                                                                            name="additionalMeasure"
                                                                            value={this.state.additionalMeasure}
                                                                            unit={this.state.additionalUnitOfMeasure}
                                                                            onChange={this.handleAdditionalMeasureChange}
                                                                        />
                                                                    </div>
                                                                </div>}
                                                            {this.isUnitPriceEditable() && !this.state.stockDocument &&
                                                                <UnitPriceInput
                                                                    productPrices={this.state.product?.attributes?.productPrices}
                                                                    selectedPriceLevelId={this.state.selectedPriceLevelId}
                                                                    unitPrice={this.state.unitPrice}
                                                                    currency={this.state.currency}
                                                                    onChange={(newUnitPrice, editItemSelectedPriceLevelId) => {
                                                                        this.setState({ unitPrice: newUnitPrice, editItemSelectedPriceLevelId: editItemSelectedPriceLevelId })
                                                                    }}
                                                                    isBundle={this.isBundle()}
                                                                />
                                                            }
                                                            {Guard.isAuthorized(Permissions.ShowMargin) && this.isUnitPriceEditable() ?
                                                                <div className="form-group form-row">
                                                                    <label
                                                                        className="col-5 col-form-label text-md-right">
                                                                        <FormattedMessage
                                                                            id="quote.add_item_modal.configure.unit_cost_label"
                                                                            defaultMessage="Unit cost"
                                                                        />
                                                                    </label>
                                                                    <div className="col-7">
                                                                        <MoneyInputForm
                                                                            currency={this.state.currency}
                                                                            name="unitCost"
                                                                            value={AppContext.isInventoryEnabled() ? this.displayEstimatedCost(this.state.product, this.state.unitCost) : this.state.unitCost}
                                                                            onChange={(newValue) => {
                                                                                this.setState({ unitCost: newValue })
                                                                            }}
                                                                            id={'unitCost'}
                                                                            disabled={AppContext.isInventoryEnabled() ? this.shouldDisableUnitCost() : false}
                                                                        />
                                                                    </div>
                                                                </div> : ''}
                                                            {Guard.isAuthorized(Permissions.ShowMargin) && this.isUnitPriceEditable() && !this.state.stockDocument ?
                                                                <div className="form-group form-row">
                                                                    <label
                                                                        className="col-5 col-form-label text-md-right">
                                                                        <FormattedMessage
                                                                            id="quote.add_item_modal.configure.unit_margin_label"
                                                                            defaultMessage="Unit margin"
                                                                        />
                                                                    </label>
                                                                    <div className={'col-7 d-flex align-items-center ' +
                                                                        (parseFloat(this.getUnitMargin()) > 0 ? 'text-success' : 'text-danger')}>
                                                                        (<FormattedNumber
                                                                            style="percent"
                                                                            value={this.getUnitMarginRatio()}
                                                                        />)
                                                                        &nbsp;
                                                                        <FormattedNumber
                                                                            style="currency"
                                                                            currency={this.state.currency}
                                                                            value={this.getUnitMargin()}
                                                                        />
                                                                    </div>
                                                                </div> : ''}
                                                            {billingMethodSelection}
                                                            {['monthly', 'yearly'].includes(this.state.billingMethod) ?
                                                                <div className="form-group form-row">
                                                                    <label className="col-5 col-form-label text-align-right"
                                                                        htmlFor="commitmentDuration">
                                                                        <FormattedMessage
                                                                            id="quote.add_item_modal.configure.commitment_duration_label"
                                                                            defaultMessage="Duration"
                                                                        />
                                                                    </label>
                                                                    <div className="col-7">
                                                                        <CommitmentDurationInput
                                                                            billingMethod={this.state.billingMethod}
                                                                            value={this.state.commitmentDuration}
                                                                            onChange={val => {
                                                                                this.setState({ commitmentDuration: val })
                                                                            }}
                                                                            name={'commitmentDuration'}
                                                                        />
                                                                    </div>
                                                                </div> : ''}
                                                            {this.state.product && this.state.itemCustomAttributes && this.renderItemCustomAttributesFields(this.state.product, this.state.itemCustomAttributes)}
                                                            <div className="form-group form-row">
                                                                <label className="col-5 col-form-label text-md-right">
                                                                    <FormattedMessage
                                                                        id="quote.add_item_modal.configure.group_label"
                                                                        defaultMessage="Group"
                                                                    />
                                                                </label>
                                                                <div className="col-7">
                                                                    <GroupSelect
                                                                        selectedGroupId={this.state.groupId}
                                                                        groups={this.state.groups}
                                                                        onChange={(groupId, newGroupName) => {
                                                                            this.setState({
                                                                                groupId,
                                                                                newGroupName,
                                                                            })
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {(this.props.object?.attributes || this.state.stockDocument)
                                                                && this.state.product?.attributes.trackSerialNumber
                                                                && Number(this.state.measure) > 0 &&
                                                                <div className="form-group form-row">
                                                                    <label className="col-5 col-form-label text-md-right">
                                                                        <FormattedMessage
                                                                            id="pricing.add_item_component.serial_number_label"
                                                                            defaultMessage="Serial numbers"
                                                                        />
                                                                    </label>
                                                                    <div className="col-7">
                                                                        <SerialNumberSelect
                                                                            isDisabled={this.validateSerialNumberHistory()}
                                                                            maxNumberOfSerialNumbers={this.state.measure}
                                                                            productID={this.state.selectedProductId}
                                                                            onChange={this.onSerialNumberChange}
                                                                            selection={this.state.serialNumbers}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    {matrixSelection}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="modal-footer">
                                    <div className="col-12">
                                        <div className="row justify-content-between d-flex flex-wrap">
                                            {!this.state.stockDocument ? (<>
                                                <div className="d-flex justify-content-start">
                                                    <button type="button"
                                                        className="btn btn-secondary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.closeModals}>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.close_btn"
                                                            defaultMessage="Close"
                                                        />
                                                    </button>
                                                    {!this.props.itemId ? <button type="button"
                                                        className="btn btn-outline-primary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.backToChooseProduct}>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.back_btn"
                                                            defaultMessage="Back"
                                                        />
                                                    </button> : ''}
                                                    {deleteBtn}
                                                </div>
                                                <div className="d-flex justify-content-end">
                                                    {this.isChoosingProductFromCurrentProductIds() &&
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mb-2 mb-lg-0 ml-md-2"
                                                                onClick={e => {
                                                                    e.preventDefault()
                                                                    let newCurrentProductIdsIndex = this.state.currentProductIdsIndex + 1
                                                                    if (newCurrentProductIdsIndex === this.state.currentProductIds.length) {
                                                                        newCurrentProductIdsIndex = 0
                                                                    }
                                                                    this.setState({
                                                                        currentProductIdsIndex: newCurrentProductIdsIndex,
                                                                    }, () => {
                                                                        if (this.state.currentProductIdsIndex > 0) {
                                                                            this.productSelect(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                                            this.chooseProductLineButton(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                                        } else {
                                                                            this.setState({
                                                                                currentProductIds: [],
                                                                                currentProductIdsIndex: 0,
                                                                            })
                                                                            this.quit(false)
                                                                        }
                                                                    })
                                                                }}>
                                                                <FormattedMessage
                                                                    id="quote.add_item_modal.configure.skip_btn"
                                                                    defaultMessage="Skip"
                                                                />
                                                            </button>
                                                        </div>
                                                    }
                                                    <ActionButton
                                                        style={{ minWidth: '8em' }}
                                                        disabled={this.state.saveAndContinueItemLoading || this.state.isSaveButtonDisabled}
                                                        // || !customAttributesAreValid(this.state.itemCustomAttributes, this.state.product?.attributes?.customAttributeDefinitions)}
                                                        isLoading={this.state.saveItemLoading}
                                                        type="submit"
                                                        className="btn btn-outline-primary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.addProduct}>
                                                        {saveBtnTxt}
                                                    </ActionButton>
                                                    {(!this.props.itemId && !this.isChoosingProductFromCurrentProductIds()) ?
                                                        <ActionButton
                                                            disabled={this.state.saveItemLoading || this.state.isSaveButtonDisabled}
                                                            //|| !customAttributesAreValid(this.state.itemCustomAttributes, this.state.product?.attributes?.customAttributeDefinitions)}
                                                            isLoading={this.state.saveAndContinueItemLoading}
                                                            type="button"
                                                            className="btn btn-primary mb-2 mb-lg-0  ml-md-2"
                                                            onClick={this.addProductAndContinue}>
                                                            <FormattedMessage
                                                                id="quote.add_item_modal.configure.add_and_continue_btn"
                                                                defaultMessage="Add & Continue Browsing"
                                                            />
                                                        </ActionButton> : ''}
                                                    {this.isChoosingProductFromCurrentProductIds() &&
                                                        <div>
                                                            {(this.state.currentProductIds.length > 1 && this.state.currentProductIdsIndex != this.state.currentProductIds.length - 1) &&
                                                                <ActionButton
                                                                    disabled={this.state.saveItemLoading}
                                                                    isLoading={this.state.saveAndContinueItemLoading}
                                                                    type="button"
                                                                    className="btn btn-primary mb-2 mb-lg-0  ml-md-2"
                                                                    onClick={e => {
                                                                        e.preventDefault()
                                                                        this.multiCreateProduct(
                                                                            this.state.currentProductIds.slice(this.state.currentProductIdsIndex, this.state.currentProductIds.length),
                                                                            this.state.groupId,
                                                                        ).then(_ => {
                                                                            this.quit(false)
                                                                        })
                                                                    }}>
                                                                    <FormattedMessage
                                                                        id="quote.add_item_modal.configure.add_all_btn"
                                                                        defaultMessage="Add item {from} to {to}"
                                                                        values={{
                                                                            from: this.state.currentProductIdsIndex + 1,
                                                                            to: this.state.currentProductIds.length,
                                                                        }}
                                                                    />
                                                                </ActionButton>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </>) : <>
                                                <div className="d-flex justify-content-start">
                                                    {!this.props.itemId ? <button type="button"
                                                        className="btn btn-outline-primary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.backToChooseProduct}>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.back_btn"
                                                            defaultMessage="Back"
                                                        />
                                                    </button> : ''}
                                                    <button type="button"
                                                        className="btn btn-secondary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.closeModals}>
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.close_btn"
                                                            defaultMessage="Close"
                                                        />
                                                    </button>
                                                </div>
                                                <div className="d-flex justify-content-end">
                                                    {this.isChoosingProductFromCurrentProductIds() &&
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mb-2 mb-lg-0 ml-md-2"
                                                                onClick={e => {
                                                                    e.preventDefault()
                                                                    let newCurrentProductIdsIndex = this.state.currentProductIdsIndex + 1
                                                                    if (newCurrentProductIdsIndex === this.state.currentProductIds.length) {
                                                                        newCurrentProductIdsIndex = 0
                                                                    }
                                                                    this.setState({
                                                                        currentProductIdsIndex: newCurrentProductIdsIndex,
                                                                    }, () => {
                                                                        if (this.state.currentProductIdsIndex > 0) {
                                                                            this.productSelect(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                                            this.chooseProductLineButton(this.state.currentProductIds[this.state.currentProductIdsIndex])
                                                                        } else {
                                                                            this.setState({
                                                                                currentProductIds: [],
                                                                                currentProductIdsIndex: 0,
                                                                            })
                                                                            this.quit(false)
                                                                        }
                                                                    })
                                                                }}>
                                                                <FormattedMessage
                                                                    id="quote.add_item_modal.configure.skip_btn"
                                                                    defaultMessage="Skip"
                                                                />
                                                            </button>
                                                        </div>
                                                    }
                                                    <ActionButton
                                                        style={{ minWidth: '8em' }}
                                                        disabled={this.state.saveAndContinueItemLoading || this.state.isSaveButtonDisabled}
                                                        // || !customAttributesAreValid(this.state.itemCustomAttributes, this.state.product?.attributes?.customAttributeDefinitions)}
                                                        isLoading={this.state.saveItemLoading}
                                                        type="submit"
                                                        className="btn btn-outline-primary mb-2 mb-lg-0  ml-md-2"
                                                        onClick={this.addProduct}>
                                                        {saveBtnTxt}
                                                    </ActionButton>
                                                    {this.isChoosingProductFromCurrentProductIds() &&
                                                        <div>
                                                            {(this.state.currentProductIds.length > 1 && this.state.currentProductIdsIndex != this.state.currentProductIds.length - 1) &&
                                                                <ActionButton
                                                                    disabled={this.state.saveItemLoading}
                                                                    isLoading={this.state.saveAndContinueItemLoading}
                                                                    type="button"
                                                                    className="btn btn-primary mb-2 mb-lg-0  ml-md-2"
                                                                    onClick={e => {
                                                                        e.preventDefault()
                                                                        this.multiCreateProduct(
                                                                            this.state.currentProductIds.slice(this.state.currentProductIdsIndex, this.state.currentProductIds.length),
                                                                            this.state.groupId,
                                                                        ).then(_ => {
                                                                            this.quit(false)
                                                                        })
                                                                    }}>
                                                                    <FormattedMessage
                                                                        id="quote.add_item_modal.configure.add_all_btn"
                                                                        defaultMessage="Add item {from} to {to}"
                                                                        values={{
                                                                            from: this.state.currentProductIdsIndex + 1,
                                                                            to: this.state.currentProductIds.length,
                                                                        }}
                                                                    />
                                                                </ActionButton>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                {/************** Quick Create Product Modal ***************/}
                <div className="modal"
                    id="quickCreateProductModal"
                    role="dialog"
                    aria-labelledby="QuickCreateProductModal"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="QuickCreateModalLabel">
                                    <FormattedMessage
                                        id="quote.quick_create_modal.title"
                                        defaultMessage="Quick create product "
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form id="quick-create-form" noValidate>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="quickProductTitle">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.title_label"
                                                            defaultMessage="Title"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <input name="quickProductTitle"
                                                            value={this.state.quickProductTitle}
                                                            onChange={this.handleQuickCreateFormChange}
                                                            id="quickProductTitle"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={this.props.intl.formatMessage(messages["product_name_placeholder"])}
                                                            required
                                                        />
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.title_description"
                                                                defaultMessage="Describe the product in a few word"
                                                            />
                                                        </small>
                                                        <div className="invalid-feedback">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.title_description_missing_message"
                                                                defaultMessage="You must provide a product title."
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="quickProductShortDescription">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.short_description_label"
                                                            defaultMessage="Short Description"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <textarea name="quickProductShortDescription"
                                                            value={this.state.quickProductShortDescription}
                                                            onChange={this.handleQuickCreateFormChange}
                                                            id="quickProductShortDescription"
                                                            rows="3"
                                                            className="form-control"
                                                            placeholder={this.props.intl.formatMessage(messages["product_short_description_placeholder"])}
                                                        />
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.short_description_description"
                                                                defaultMessage="This description can be used on proposal on line items"
                                                            />
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="quickProductShortDescription">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.images_label"
                                                            defaultMessage="Images"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <ImageUploaderDropZone
                                                            onUpdateImageList={this.handleImageChange}
                                                            maxFiles={5}
                                                            images={this.state.quickProductImages}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="quickProductBillingMethod">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.billing_method_label"
                                                            defaultMessage="Billing method"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <select name="billingMethod"
                                                            value={this.state.billingMethod}
                                                            onChange={this.handleQuickCreateFormChange}
                                                            id="billingMethod"
                                                            className="form-control"
                                                        >
                                                            <option value={"one-time"}>
                                                                {LabelHelper.getBillingMethodLabel(this.props.intl, 'one-time', false)}
                                                            </option>
                                                            <option value={"monthly"}>
                                                                {LabelHelper.getBillingMethodLabel(this.props.intl, 'monthly', false)}
                                                            </option>
                                                            <option value={"yearly"}>
                                                                {LabelHelper.getBillingMethodLabel(this.props.intl, 'yearly', false)}
                                                            </option>
                                                        </select>
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.billing_method_description"
                                                                defaultMessage="Billing method defines if the item is recurring or not"
                                                            />
                                                        </small>
                                                    </div>
                                                </div>
                                                {['monthly', 'yearly'].includes(this.state.billingMethod) ?
                                                    <div className="form-group row">
                                                        <label className="col-2 col-form-label text-align-right"
                                                            htmlFor="commitmentDuration">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.commitment_duration_label"
                                                                defaultMessage="Duration"
                                                            />
                                                        </label>
                                                        <div className="col-10">
                                                            <CommitmentDurationInput
                                                                billingMethod={this.state.billingMethod}
                                                                value={this.state.commitmentDuration}
                                                                onChange={val => {
                                                                    this.setState({ commitmentDuration: val })
                                                                }}
                                                                name={'commitmentDuration'}
                                                            />
                                                            <small className="form-text text-muted">
                                                                <FormattedMessage
                                                                    id="quote.quick_create_modal.commitment_duration_description"
                                                                    defaultMessage="Commitment duration of the recurring product"
                                                                />
                                                            </small>
                                                        </div>
                                                    </div> : ''}
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="productDefaultUnitPrice">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.default_unit_price_label"
                                                            defaultMessage="Unit price"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <MoneyInputForm
                                                            currency={this.state.currency}
                                                            name="quickProductUnitPrice"
                                                            value={this.state.quickProductUnitPrice}
                                                            onChange={val => {
                                                                this.setState({ quickProductUnitPrice: val })
                                                            }}
                                                            id={'quickProductUnitPrice'}
                                                        />
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.default_unit_price_description"
                                                                defaultMessage="The unit price is used to calculate the quote total"
                                                            />
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="productDefaultUnitPrice">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.default_unit_cost_label"
                                                            defaultMessage="Unit cost"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <MoneyInputForm
                                                            currency={this.state.currency}
                                                            name="quickProductUnitCost"
                                                            value={this.state.quickProductUnitCost}
                                                            onChange={val => {
                                                                this.setState({ quickProductUnitCost: val })
                                                            }}
                                                        />
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.default_unit_cost_description"
                                                                defaultMessage="The unit cost is used to calculate the margin"
                                                            />
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right"
                                                        htmlFor="productUnitOfMeasure">
                                                        <FormattedMessage
                                                            id="quote.quick_create_modal.unit_of_measure_label"
                                                            defaultMessage="Unit of Measure"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <SelectUnitOfMeasure
                                                            name="quickProductUnitOfMeasure"
                                                            value={this.state.quickProductUnitOfMeasure}
                                                            onChange={this.handleUnitOfMeasureChange}
                                                            required={true}
                                                        />
                                                        <small className="form-text text-muted">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.unit_of_measure_description"
                                                                defaultMessage="The unit of measure used to define the quantity of the product or service"
                                                            />
                                                        </small>
                                                        <div className="invalid-feedback">
                                                            <FormattedMessage
                                                                id="quote.quick_create_modal.unit_of_measure_missing_field"
                                                                defaultMessage="You must specify the unit of measurement."
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-2 col-form-label text-align-right">
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.quantity_label"
                                                            defaultMessage="Quantity"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <InputUnitOfMeasure
                                                            name="measure"
                                                            allowNegative={this.mainObject == 'orders' ? false : true}
                                                            value={this.state.quickProductMeasure}
                                                            unit={this.state.quickProductUnitOfMeasure}
                                                            onChange={this.handleQuickProductMeasureChange}
                                                            id={'quickProductMeasure'}
                                                        />
                                                    </div>
                                                </div>
                                                {groups.length > 0 ? <div className="form-group form-row">
                                                    <label className="col-2 col-form-label text-align-right">
                                                        <FormattedMessage
                                                            id="quote.add_item_modal.configure.group_label"
                                                            defaultMessage="Group"
                                                        />
                                                    </label>
                                                    <div className="col-10">
                                                        <select className={'form-control'}
                                                            value={this.state.groupId}
                                                            onChange={e => {
                                                                this.setState({ groupId: e.target.value })
                                                            }}>
                                                            <option value={''}>
                                                                {this.props.intl.formatMessage(messages['quote.add_item_modal.configure.no_group_label'])}
                                                            </option>
                                                            {groups.map(g => {
                                                                return <option key={g.id} value={g.id}>
                                                                    {g.attributes.name}
                                                                </option>
                                                            })}
                                                        </select>
                                                    </div>
                                                </div> : ''}
                                                {addToCatalogCheckBox}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <div className="col-12 text-align-right">
                                    <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                        <FormattedMessage
                                            id="quote.add_item_modal.configure.close_btn"
                                            defaultMessage="Close"
                                        />
                                    </button>
                                    {deleteBtn}
                                    <button type="submit" className="btn btn-primary ml-2"
                                        onClick={this.addQuickProduct}>
                                        {saveBtnTxt}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </>)
    }
}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.objectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        totals: getPricingTableTotals(state, objectId),
        itemTax: getPricingTableItemTax(state, item, objectId),
        groups: getPricingTableGroups(state, objectId),
        documentInventoryLocations: InventoryLocationSelector.getListing(state),
    }
}
export default connect(mapState)(injectIntl(AddPricingRow))


// WEBPACK FOOTER //
// ./src/common/pricing/addItem.component.jsx